// extracted by mini-css-extract-plugin
export default {"Cacao":"#645B57","ScreenSMMax":"(max-width: 991px)","closeIcon":"G3db21e G5e65f6 Ga51246"};